import { useEffect, useRef } from "react";

export default (type, handler, ref, options = {}) => {
  const cache = useRef({});

  // Maintaining the handler & options in cache
  // so that we can avoid adding them to the deps array
  // of the last useEffect call, and reduce the calls
  // to add/remove listeners.
  useEffect(() => {
    cache.current = { handler, options };
  }, [handler, options]);

  useEffect(() => {
    const handler = (e) => cache.current.handler(e);
    const options = { ...cache.current.options };
    const element = ref.current;

    element?.addEventListener?.(type, handler, options);

    return () => element?.removeEventListener?.(type, handler, options);
  }, [type, ref]);
};
